import * as z from 'zod';

export const MAXIMO_FILTRO = 150;
export const MAXIMO_OBSERVACAO = 100;
export const MAXIMO_AUTOR = 50;

/**
 * Um campo de texto do filtro. Além de string aceita número e booleano e os converte para texto,
 * para quem digita o filtro direto na URL não precisar de aspas. Tolerante (`catch`) e com
 * default, então um valor estranho, ou maior que o `maximo` do formulário, cai no padrão em vez de
 * derrubar a rota.
 */
const texto = (maximo?: number) =>
  z
    .union([z.string(), z.number(), z.boolean()])
    .transform(valor => String(valor))
    .pipe(maximo === undefined ? z.string() : z.string().max(maximo))
    .catch('')
    .default('');

/** Uma data `yyyy-MM-dd` que existe no calendário. Qualquer outro valor cai no padrão. */
const data = () => z.iso.date().catch('').default('');

/** Os blocos de resultado que abrem uma tabela de detalhe. */
export const TIPOS_CLIENTES = ['web', 'hibridos', 'aquisicoes'] as const;

const marcado = () => z.boolean().catch(true).default(true);

/**
 * O filtro inteiro vive na URL, para sobreviver ao F5 e poder ser compartilhado (issue 14534).
 * Um período com o início depois do fim cai no padrão, como o formulário, que não aceita esse
 * período.
 */
export const searchSchema = z
  .object({
    filtro: texto(MAXIMO_FILTRO),
    dataInicio: data(),
    dataFim: data(),
    observacao: texto(MAXIMO_OBSERVACAO),
    autor: texto(MAXIMO_AUTOR),

    mostrarAquisicoes: marcado(),
    mostrarMensalidades: marcado(),
    mostrarAnuidades: marcado(),
    mostrarClientesAtivos: marcado(),
    mostrarClientesBloqueados: marcado(),
    mostrarClientesVencidosOuCancelados: marcado(),

    mostrarServicosEmCobranca: marcado(),
    mostrarServicosEmDemonstracao: marcado(),
    mostrarServicosBloqueados: marcado(),
    mostrarServicosExcluidos: marcado(),

    detalhe: z.enum(TIPOS_CLIENTES).optional().catch(undefined),
    software: texto(),
    pagina: z.number().min(1).catch(1).default(1),
  })
  .transform(search =>
    search.dataInicio && search.dataFim && search.dataInicio > search.dataFim
      ? { ...search, dataInicio: '', dataFim: '' }
      : search,
  );

export type ClientesSearch = z.infer<typeof searchSchema>;
